<template>
    <a :href="`/services/${service.slug}`">
        <div class="p-4 bg-white rounded-lg border border-gray-300 shadow h-full flex flex-col justify-between">
            <div>
                <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between">
                    <h3 class="text-2xl flex-1 text-teal-600 font-bold">{{ service.name }}</h3>
                    <p class="uppercase text-sm sm:text-base text-gray-600">
                        {{ service.currency.symbol }}{{ `${service.cost} ${service.currency.name}` }}
                    </p>
                </div>
                <p class="mt-2 line-clamp-5 text-gray-700" v-html="service.description"></p>
            </div>
            <a :href="`/profiles/${service.user.username}`" class="flex items-center text-gray-900 mt-4 hover-text-teal-600">
                <div class="avatar w-12 h-12 mr-2 border-gray-500 border rounded-full">
                    <user-avatar :avatar-url="service.user.avatar_url" :username="service.user.name"></user-avatar>
                </div>
                <span class="name flex flex-col items-start leading-none">
                    <div class="normal-case font-bold text-base hover:text-teal-600 mb-1">{{ service.user.name }}</div>
                    <div class="text-gray-500 normal-case">{{ service.user.profile.title }}</div>
                </span>
            </a>
        </div>
    </a>
</template>

<script>
export default {
    props: {
        service: {
            type: Object,
            required: true
        }
    }
};
</script>
